const moduleOrder = [
  'grower-activity',
  'mangrove-data',
  'AMS',
  'utilities',
  'masters',
  'employees',
  'users',
  'users-old',
  'profile'
]
export default moduleOrder


// WEBPACK FOOTER //
// ./src/modules/_order.js